import * as React from 'react';

const useRerender = () => {
  const [_, setRerender] = React.useState(false);
  return React.useCallback(() => setRerender((prev) => !prev), []);
};

export default useRerender;
